import InterviewForm from "./js/InterviewForm";

export default InterviewForm;
